
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRain as ObiLightningRainElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain.js';
 
 
 

 
 export const ObiLightningRain = createComponent({
   react: React,
   tagName: 'obi-lightning-rain',
   elementClass: ObiLightningRainElement,
   events: {
     
   }
  });
 
 